module.exports = __webpack_public_path__ + "img/MITDCI.5da8105e.png";